import { useState, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import EnvelopeOpening from './components/EnvelopeOpening';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CountdownSection from './components/CountdownSection';
import CoupleSection from './components/CoupleSection';
import EventsSection from './components/EventsSection';
import InvitationSection from './components/InvitationSection';
import ComplimentsSection from './components/ComplimentsSection';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ParticleBackground from './components/ParticleBackground';

export default function Home() {
  const [envelopeOpened, setEnvelopeOpened] = useState(false);

  const handleEnvelopeOpen = useCallback(() => {
    setTimeout(() => {
      setEnvelopeOpened(true);
    }, 500);
  }, []);

  return (
    <main className="min-h-screen bg-midnight-dark overflow-x-hidden">
      {/* Always render particles behind */}
      {envelopeOpened && <ParticleBackground />}

      <AnimatePresence mode="wait">
        {!envelopeOpened && (
          <EnvelopeOpening
            key="envelope"
            onOpen={handleEnvelopeOpen}
          />
        )}
      </AnimatePresence>

      {envelopeOpened && (
        <>
          <Navbar />
          <HeroSection />
          <CountdownSection />
          <CoupleSection />
          <EventsSection />
          <InvitationSection />
          <ComplimentsSection />
          <Footer />
          <FloatingButtons />
        </>
      )}
    </main>
  );
}